import { createFileRoute } from "@tanstack/react-router";
import { ProjectsListView } from "@/features/projects";

export const Route = createFileRoute("/projects/")({
	component: ProjectsListView,
});
